// Material 3 eases
// https://m3.material.io/styles/motion/easing-and-duration/tokens-specs
export function registerMaterial3(CustomEase) {
	CustomEase.create(
		'm3.emphasized',
		'M 0,0 C 0.05, 0, 0.133333, 0.06, 0.166666, 0.4 C 0.208333, 0.82, 0.25, 1, 1, 1',
	)
	CustomEase.create('m3.emphasized.accelerate', '0.3,0,0.8,0.15')
	CustomEase.create('m3.emphasized.decelerate', '0.05,0.7,0.1,1')
	CustomEase.create('m3.standard', '0.2,0,0,1')
	CustomEase.create('m3.standard.accelerate', '0.3,0,1,1')
	CustomEase.create('m3.standard.decelerate', '0,0,0,1')
	CustomEase.create('m3.legacy', '0.4,0,0.2,1')
	CustomEase.create('m3.legacy.accelerate', '0.4,0,1,1')
	CustomEase.create('m3.legacy.decelerate', '0,0,0.2,1')
}
